import { FC } from "react";
import { Helmet } from "react-helmet";

interface PageHeadProps {
  title: string;
  description?: string;
  robots?: string;
  keywords?: string;
  canonicalUrl?: string;
}

/**
 * PageHead component provides consistent document head management using React Helmet.
 * Follows HTML best practices from internal documentation standards.
 *
 * @param title - The page title (required)
 * @param description - Meta description for SEO
 * @param robots - Robots directive (defaults to "noindex, follow" for institutional pages)
 * @param keywords - Meta keywords for the page
 * @param canonicalUrl - Canonical URL for the page
 */
const PageHead: FC<PageHeadProps> = ({
  title,
  description = "Capital Group Institutional Services",
  robots = "noindex, follow",
  keywords,
  canonicalUrl,
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={robots} />
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
};

export default PageHead;
